import api from "./apiUsersManagement.js";

export default {
  GetGroupById(id) {
    return api.get("Groups/SingleRead/" + id);
  },

  FastUserInitialize(user) {
    return api.post("Users/FastUserInitialize", user);
  }
};
